export const ROW_TYPE = Object.freeze({
    PRODUCT: 'product',
    SHIPPING: 'shipping',
    PACKAGING: 'packaging',
    CATALOG: 'catalog',
    SINGLE: 'single',
    SUB_TOTAL: 'sub-total',
    BREAK_LINE: 'break-line',
    BREAK_PAGE: 'break-page',
    COMMENT: 'comment',
    TITLE: 'title',
    PROGRESS_PRODUCT: 'progress-product',
    PROGRESS_SHIPPING: 'progress-shipping',
    PROGRESS_PACKAGING: 'progress-packaging',
    PROGRESS_SINGLE: 'progress-single',
    PROGRESS_CATALOG: 'progress-catalog',
    DEPOSIT: 'deposit',
});

export const PROGRESS_TYPES = Object.freeze({
    GLOBAL: 'global',
    PER_LINE: 'per-line',
});

export const DOCUMENT_TYPE = Object.freeze({
    ESTIMATE: 'estimate',
    ORDER: 'order',
    INVOICE: 'invoice',
    CREDIT_NOTE: 'creditnote',
    PROFORMA: 'proforma',
});
export const ANALYTIC_CODE_TYPE = Object.freeze({
    DOCUMENT: 'document',
    ITEM: 'item',
});

export const ERROR_CATEGORIES = Object.freeze({
    PAYMENT_SETTINGS: 'PaymentSettings',
    SHIPPING_SETTINGS: 'ShippingSettings',
    DOCUMENT: 'Document',
    CUSTOMFIELDS: 'CustomFields',
});

export const ERROR_TYPES = Object.freeze({
    DEADLINE_AMOUNT: 'deadline_amount',
    DEPOSIT_AMOUNT: 'deposit_amount',
    CUSTOMFIELDS: 'customfields',
    DEADLINE_EMPTY_AMOUNT: 'deadline_empty_amount',
    DEADLINE_EMPTY_DATE: 'deadline_empty_date',
    DEADLINE_DUPLICATE_DATE: 'deadline_duplicate_date',
    XDAYS: 'xdays',
    DUE_DATE: 'due_date',
    INVALID_TRACKING_URL: 'invalidTrackingUrl',
    INVALID_TRACKING_NUMBER: 'invalidTrackingNumber',
});

export const CODE = Object.freeze({
    THIRTYDAYS: '30days',
    FORTYFIVEDAYS: '45days',
    SIXTYDAYS: '60days',
    XDAYS: 'xdays',
    CUSTOM: 'custom',
    SCALED: 'scaled',
    ONORDER: 'onorder',
    ENDMONTH: 'endmonth',
    NEXTMONTH: 'nextmonth',
    ONINVOICE: 'oninvoice',
    NONE: 'none',
    RECEIVED: 'received',
    DEADLINES: 'deadlines',
});

export const INVOICE_TYPES = Object.freeze({
    PROGRESS: 'progress-invoice',
    DEPOSIT: 'deposit-invoice',
});

export const DOC_TYPES = Object.freeze({
    PROGRESS_INVOICE: 'progress-invoice',
    DEPOSIT_INVOICE: 'deposit-invoice',
});
